$(window).on("load resize", function(){
var alturamaxima = 0;
	$('.box-shadow').each(function() {
		if ( $(this).height() > alturamaxima ){
			alturamaxima = $(this).height()
		}
	});
$('.box-shadow').height( alturamaxima );
});
